export const ingredients = [
    {
        name: 'Alit Hide',
        effects: [
            'Drain Intelligence',
            'Resist Poison',
            'Telekinesis',
            'Detect Animal'
        ],
        value: 5,
        weight: 1
    },
    {
        name: 'Ampoule Pod',
        effects: [
            'Water Walking',
            'Paralyze',
            'Detect Animal',
            'Drain Willpower'
        ],
        value: 2,
        weight: 0.1
    },
    {
        name: 'Ash Salts',
        effects: [
            'Drain Agility',
            'Resist Magicka',
            'Cure Blight Disease',
            'Resist Magicka'
        ],
        value: 25,
        weight: 0.1
    },
    {
        name: 'Ash Yam',
        effects: [
            'Fortify Intelligence',
            'Fortify Strength',
            'Resist Common Disease',
            'Detect Key'
        ],
        value: 1,
        weight: 0.5
    },
    {
        name: 'Bittergreen Petals',
        effects: [
            'Restore Intelligence',
            'Invisibility',
            'Drain Endurance',
            'Drain Magicka'
        ],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Black Anther',
        effects: [
            'Drain Agility',
            'Resist Fire',
            'Drain Endurance',
            'Light'
        ],
        value: 2,
        weight: 0.1
    },
    {
        name: 'Black Lichen',
        effects: ['Drain Strength', 'Resist Frost', 'Drain Speed', 'Cure Poison'],
        value: 2,
        weight: 0.1
    },
    {
        name: 'Bloat',
        effects: [
            'Drain Magicka',
            'Fortify Intelligence',
            'Fortify Willpower',
            'Detect Animal'
        ],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Bonemeal',
        effects: [
            'Restore Agility',
            'Telekinesis',
            'Drain Fatigue',
            'Drain Personality'
        ],
        value: 2,
        weight: 0.2
    },
    {
        name: 'Bread',
        effects: ['Restore Fatigue'],
        value: 1,
        weight: 0.2
    },
    {
        name: "Bungler's Bane",
        effects: ['Drain Speed', 'Drain Endurance', 'Dispel', 'Drain Strength'],
        value: 1,
        weight: 0.5
    },
    {
        name: 'Chokeweed',
        effects: [
            'Drain Luck',
            'Restore Fatigue',
            'Cure Common Disease',
            'Drain Willpower'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Coda Flower',
        effects: [
            'Drain Personality',
            'Levitate',
            'Drain Intelligence',
            'Drain Health'
        ],
        value: 23,
        weight: 0.1
    },
    {
        name: 'Comberry',
        effects: ['Drain Fatigue', 'Restore Magicka', 'Fire Shield',
            'Reflect'],
        value: 2,
        weight: 0.1
    },
    {
        name: 'Corkbulb Root',
        effects: [
            'Cure Paralyzation',
            'Restore Health',
            'Lightning Shield',
            'Fortify Luck'
        ],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Corprus Weepings',
        effects: [
            'Drain Fatigue',
            'Fortify Luck',
            'Drain Willpower',
            'Restore Health'
        ],
        value: 50,
        weight: 0.1
    },
    {
        name: 'Crab Meat',
        effects: [
            'Restore Fatigue',
            'Resist Shock',
            'Lightning Shield',
            'Restore Luck'
        ],
        value: 1,
        weight: 0.5
    },
    {
        name: 'Daedra Skin',
        effects: [
            'Fortify Strength',
            'Cure Common Disease',
            'Paralyze',
            'Swift Swim'
        ],
        value: 200,
        weight: 0.2
    },
    {
        name: "Daedra's Heart",
        effects: [
            'Restore Magicka',
            'Fortify Endurance',
            'Drain Agility',
            'Night Eye'
        ],
        value: 200,
        weight: 1
    },
    {
        name: 'Diamond',
        effects: ['Drain Agility', 'Invisibility', 'Reflect', 'Detect Key'],
        value: 250,
        weight: 0.2
    },
    {
        name: 'Dreugh Wax',
        effects: [
            'Fortify Strength',
            'Restore Strength',
            'Drain Luck',
            'Drain Willpower'
        ],
        value: 100,
        weight: 0.2
    },
    {
        name: 'Ectoplasm',
        effects: [
            'Fortify Agility',
            'Detect Animal',
            'Drain Strength',
            'Drain Health'
        ],
        value: 10,
        weight: 0.1
    },
    {
        name: 'Emerald',
        effects: [
            'Fortify Magicka',
            'Restore Health',
            'Drain Agility',
            'Drain Endurance'
        ],
        value: 150,
        weight: 0.2
    },
    {
        name: 'Fire Petal',
        effects: ['Resist Fire', 'Drain Health', 'Spell Absorption',
            'Paralyze'],
        value: 2,
        weight: 0.1
    },
    {
        name: 'Fire Salts',
        effects: [
            'Drain Health',
            'Fortify Agility',
            'Resist Frost',
            'Fire Shield'
        ],
        value: 100,
        weight: 0.1
    },
    {
        name: 'Frost Salts',
        effects: ['Drain Speed', 'Restore Magicka', 'Frost Shield', 'Resist Fire'],
        value: 75,
        weight: 0.1
    },
    {
        name: 'Ghoul Heart',
        effects: ['Paralyze', 'Cure Poison', 'Fortify Attack'],
        value: 150,
        weight: 0.5
    },
    {
        name: 'Gold Kanet',
        effects: ['Drain Health', 'Burden', 'Drain Luck', 'Restore Strength'],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Gravedust',
        effects: [
            'Drain Intelligence',
            'Cure Common Disease',
            'Drain Magicka',
            'Restore Endurance'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Green Lichen',
        effects: [
            'Fortify Personality',
            'Cure Common Disease',
            'Drain Strength',
            'Drain Health'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Guar Hide',
        effects: [
            'Drain Fatigue',
            'Fortify Endurance',
            'Restore Personality',
            'Fortify Luck'
        ],
        value: 5,
        weight: 1
    },
    {
        name: 'Hackle-Lo Leaf',
        effects: [
            'Restore Fatigue',
            'Paralyze',
            'Water Breathing',
            'Restore Luck'
        ],
        value: 30,
        weight: 0.1
    },
    {
        name: 'Heather',
        effects: [
            'Restore Personality',
            'Feather',
            'Drain Speed',
            'Drain Personality'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Hound Meat',
        effects: [
            'Restore Fatigue',
            'Fortify Fatigue',
            'Reflect',
            'Detect Enchantment'
        ],
        value: 2,
        weight: 1
    },
    {
        name: 'Hypha Facia',
        effects: [
            'Drain Luck',
            'Drain Agility',
            'Drain Fatigue',
            'Detect Enchantment'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Kagouti Hide',
        effects: [
            'Drain Fatigue',
            'Fortify Speed',
            'Resist Common Disease',
            'Night Eye'
        ],
        value: 2,
        weight: 1
    },
    {
        name: 'Kresh Fiber',
        effects: [
            'Restore Luck',
            'Fortify Personality',
            'Drain Magicka',
            'Drain Speed'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Kwama Cuttle',
        effects: [
            'Resist Poison',
            'Drain Fatigue',
            'Water Walking',
            'Water Breathing'
        ],
        value: 2,
        weight: 0.1
    },
    {
        name: 'Large Kwama Egg',
        effects: ['Restore Fatigue', 'Paralyze', 'Frost Shield', 'Fortify Health'],
        value: 2,
        weight: 2
    },
    {
        name: 'Luminous Russula',
        effects: ['Water Breathing', 'Drain Fatigue', 'Poison'],
        value: 1,
        weight: 0.2
    },
    {
        name: 'Marshmerrow',
        effects: [
            'Restore Health',
            'Detect Enchantment',
            'Drain Willpower',
            'Drain Fatigue'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Moon Sugar',
        effects: ['Fortify Speed', 'Dispel', 'Drain Endurance', 'Drain Luck'],
        value: 50,
        weight: 0.1
    },
    {
        name: 'Muck',
        effects: [
            'Drain Intelligence',
            'Detect Key',
            'Drain Personality',
            'Cure Common Disease'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Netch Leather',
        effects: [
            'Fortify Endurance',
            'Fortify Intelligence',
            'Drain Personality',
            'Cure Paralyzation'
        ],
        value: 1,
        weight: 1
    },
    {
        name: 'Pearl',
        effects: [
            'Drain Agility',
            'Dispel',
            'Water Breathing',
            'Resist Common Disease'
        ],
        value: 100,
        weight: 0.2
    },
    {
        name: 'Racer Plumes',
        effects: ['Drain Willpower', 'Levitate'],
        value: 20,
        weight: 0.1
    },
    {
        name: 'Rat Meat',
        effects: ['Drain Magicka', 'Paralyze', 'Cure Poison', 'Resist Poison'],
        value: 1,
        weight: 1
    },
    {
        name: 'Raw Ebony',
        effects: ['Drain Agility', 'Cure Poison', 'Frost Shield', 'Restore Speed'],
        value: 200,
        weight: 10
    },
    {
        name: 'Raw Glass',
        effects: [
            'Drain Intelligence',
            'Drain Strength',
            'Drain Speed',
            'Fire Shield'
        ],
        value: 200,
        weight: 2
    },
    {
        name: 'Red Lichen',
        effects: ['Drain Speed', 'Light', 'Cure Common Disease', 'Drain Magicka'],
        value: 25,
        weight: 0.1
    },
    {
        name: 'Resin',
        effects: [
            'Restore Health',
            'Restore Speed',
            'Burden',
            'Resist Common Disease'
        ],
        value: 10,
        weight: 0.1
    },
    {
        name: 'Roobrush',
        effects: [
            'Fortify Agility',
            'Drain Willpower',
            'Drain Health',
            'Cure Poison'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Ruby',
        effects: [
            'Drain Health',
            'Feather',
            'Restore Intelligence',
            'Drain Agility'
        ],
        value: 200,
        weight: 0.2
    },
    {
        name: 'Saltrice',
        effects: [
            'Restore Fatigue',
            'Fortify Magicka',
            'Drain Strength',
            'Restore Health'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Scales',
        effects: [
            'Drain Personality',
            'Water Walking',
            'Restore Endurance',
            'Swift Swim'
        ],
        value: 2,
        weight: 0.2
    },
    {
        name: 'Scamp Skin',
        effects: [
            'Drain Magicka',
            'Cure Paralyzation',
            'Restore Personality',
            'Restore Strength'
        ],
        value: 10,
        weight: 0.1
    },
    {
        name: 'Scathecraw',
        effects: [
            'Drain Strength',
            'Cure Poison',
            'Drain Health',
            'Restore Willpower'
        ],
        value: 2,
        weight: 0.1
    },
    {
        name: 'Scrap Metal',
        effects: [
            'Drain Health',
            'Lightning Shield',
            'Resist Shock',
            'Restore Intelligence'
        ],
        value: 20,
        weight: 10
    },
    {
        name: 'Scrib Jelly',
        effects: [
            'Fortify Willpower',
            'Cure Poison',
            'Cure Blight Disease',
            'Restore Willpower'
        ],
        value: 10,
        weight: 0.1
    },
    {
        name: 'Scrib Jerky',
        effects: ['Restore Fatigue', 'Fortify Fatigue', 'Burden', 'Swift Swim'],
        value: 5,
        weight: 0.2
    },
    {
        name: 'Scuttle',
        effects: ['Restore Fatigue', 'Fortify Fatigue', 'Feather', 'Telekinesis'],
        value: 10,
        weight: 0.1
    },
    {
        name: 'Shalk Resin',
        effects: [
            'Drain Fatigue',
            'Fortify Health',
            'Drain Personality',
            'Fortify Speed'
        ],
        value: 50,
        weight: 0.1
    },
    {
        name: 'Sload Soap',
        effects: [
            'Drain Personality',
            'Fortify Agility',
            'Fire Shield',
            'Restore Agility'
        ],
        value: 50,
        weight: 0.1
    },
    {
        name: 'Small Kwama Egg',
        effects: ['Restore Fatigue'],
        value: 1,
        weight: 0.5
    },
    {
        name: 'Spore Pod',
        effects: ['Drain Strength', 'Drain Fatigue', 'Detect Key', 'Paralyze'],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Stoneflower Petals',
        effects: [
            'Restore Strength',
            'Fortify Magicka',
            'Drain Luck',
            'Fortify Personality'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Trama Root',
        effects: ['Restore Willpower', 'Levitate', 'Drain Magicka', 'Drain Speed'],
        value: 10,
        weight: 0.1
    },
    {
        name: 'Vampire Dust',
        effects: [
            'Fortify Health',
            'Fortify Strength',
            'Spell Absorption',
            'Vampirism'
        ],
        value: 500,
        weight: 0.1
    },
    {
        name: 'Violet Coprinus',
        effects: ['Water Walking', 'Drain Fatigue', 'Poison'],
        value: 1,
        weight: 0.5
    },
    {
        name: 'Void Salts',
        effects: [
            'Restore Magicka',
            'Spell Absorption',
            'Paralyze',
            'Drain Endurance'
        ],
        value: 100,
        weight: 0.1
    },
    {
        name: 'Wickwheat',
        effects: [
            'Restore Health',
            'Fortify Willpower',
            'Paralyze',
            'Damage Intelligence'
        ],
        value: 1,
        weight: 0.1
    },
    {
        name: 'Willow Anther',
        effects: [
            'Drain Personality',
            'Frost Shield',
            'Cure Common Disease',
            'Cure Paralyzation'
        ],
        value: 10,
        weight: 0.1
    }
];